import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import ContactUs from '../pages/ContactUs';
import UsageGuide from '../pages/UsageGuide';
import BcsFlowGuide from '../pages/BcsFlowGuide';

function HomeRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <Redirect to={`${routes.HELP}/${routes.USAGE_GUIDE}`} />
                </Route>
                <Route path={`${path}/${routes.USAGE_GUIDE}`}>
                    <UsageGuide />
                </Route>
                <Route path={`${path}/${routes.BCS_FLOW_GUIDE}`}>
                    <BcsFlowGuide />
                </Route>
                <Route path={`${path}/${routes.CONTACT_US}`}>
                    <ContactUs />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default HomeRouter;
